define('poker',['module', 'jquery', 'all/player/session', 'all/dialog', 'all/footer', 'all/pretty-links', 'all/slidingContentWrapper'], function(module, $, session, dialog, footer, prettyLinks, slidingContentWrapper) {
	'use strict';

	// TODO: window.poker is a workaround for onclicks etc, change to initializers, affected are filterGameType() and openTournament() in poker.js
	var poker = window.poker = {};
	var configuration = module.config();

	var TAB_ACTIVE = 'tab-active';
	var TAB_NOT_ACTIVE = 'tab-notactive';

	var startTab = 'tab-pokerstart';
	var tournamentsTab = 'tab-tournaments';
	var rewardsTab = 'tab-rewards';
	var infoTab = 'tab-download';
	var bonusTab = 'tab-bonuses';

	var startPage = 'page-pokerstart';
	var tournamentPage = 'page-tournaments';
	var rewardsPage = 'page-rewards';
	var infoPage = 'page-download';
	var bonusPage = 'tab-bonuses';

	poker.previousHash = '';

	function isInternetExplorerLessThanEight() {
		var versionNumber = navigator.appVersion;
		var startPosition = versionNumber.lastIndexOf('MSIE');
		var ieVersion = versionNumber.substr(startPosition + 5, 3);

		return navigator.appName === 'Microsoft Internet Explorer' && ieVersion < 8.0;
	}

	function changePage(pageId) {
		document.getElementById(startPage).style.display = 'none';
		document.getElementById(tournamentPage).style.display = 'none';
		document.getElementById(rewardsPage).style.display = 'none';
		document.getElementById(infoPage).style.display = 'none';

		document.getElementById(pageId).style.display = 'block';
	}

	poker.changeNavTab = function(tabId) {

		var $tabs = $('#tab-navigation').find('a:not(:last)');
		$tabs.removeClass(TAB_ACTIVE);
		$tabs.addClass(TAB_NOT_ACTIVE);

		if (tabId !== bonusTab) {
			document.getElementById(tabId).className = TAB_ACTIVE;
		}

		if (tabId === startTab) {
			changePage(startPage);
		} else if (tabId === tournamentsTab) {
			changePage(tournamentPage);
		} else if (tabId === rewardsTab) {
			changePage(rewardsPage);
		} else if (tabId === infoTab) {
			changePage(infoPage);
		} else if (tabId === bonusTab) {
			changePage(bonusPage);
		}
	};

	/**
	 * Populates the poker start tournament list
	 */
	poker.initStartTournamentStartPage = function(nrOfTourn) {
		var $list = $('tr.startingsoon-pokerstart-tourn');
		$list.each(function(i, el) {
			var $el = $(el);
			if (i > nrOfTourn - 1) {
				$el.css({display: 'none'});
			} else {
				if (isInternetExplorerLessThanEight()) {
					$el.show();
				} else {
					$el.css({display: 'table-row'});
				}
			}
		});

		if ($list.length === 0) {
			if (isInternetExplorerLessThanEight()) {
				document.getElementById('no-tournaments-show-tr').style.display = 'block';
			} else {
				document.getElementById('no-tournaments-show-tr').style.display = 'table-row';
			}
		} else {
			document.getElementById('no-tournaments-show-tr').style.display = 'none';
		}
	};

	poker.initStartTournamentTournPage = function(nrOfTourn) {
		var $list = $('tr.startingsoon-tournaments-tourn');
		$list.each(function(i, el) {
			var $el = $(el);
			if (i > nrOfTourn - 1) {
				$el.css({display: 'none'});
			} else {
				if (isInternetExplorerLessThanEight()) {
					$el.show();
				} else {
					$el.css({display: 'table-row'});
				}
			}
		});

		if ($list.length === 0) {
			if (isInternetExplorerLessThanEight()) {
				document.getElementById('no-tournaments-show-tourn-tr').style.display = 'block';
			} else {
				document.getElementById('no-tournaments-show-tourn-tr').style.display = 'table-row';
			}
		} else {
			document.getElementById('no-tournaments-show-tourn-tr').style.display = 'none';
		}
	};

	/**
	 * Counter functionality.
	 */
	var PokerCounter = function(timeToZero, trId, tdId) {
		this.timeToZero = timeToZero;
		this.trId = trId;
		this.tdId = tdId;
	};

	poker.tickAllCounters = function() {
		poker.tickCounter();
		poker.tickCounter2();
	};

	var counterArr = [];
	poker.initCounter = function(timeToZero, trId, tdId) {
		var counter = {
			timeToZero: timeToZero,
			trId: trId,
			tdId: tdId
		};
		counterArr.push(counter);
	};

	poker.tickCounter = function() {
		var i;
		for (i = 0; i < counterArr.length; i++) {
			var counter = counterArr[i];

			var oldTime = counter.timeToZero;

			var timeNode;
			var timeShowNode;
			if (counter.timeToZero <= 0) {
				var nodeDel = document.getElementById(counter.trId);
				nodeDel.parentNode.removeChild(nodeDel);
				counterArr.splice(i, 1);
				poker.initStartTournamentStartPage();
				continue;
			} else if (counter.timeToZero < 1000 * 60) {
				timeNode = Math.floor(counter.timeToZero / 1000);
				timeShowNode = 'SEC';
			} else {
				timeNode = Math.floor(counter.timeToZero / (1000 * 60));
				timeShowNode = 'MIN';
			}

			$('#' + counter.tdId).text(timeNode);
			$('#' + counter.tdId + '-unit').text(timeShowNode);
			counter.timeToZero = oldTime - 1000;
		}
	};

	// For tournament page
	var counterArr2 = [];
	poker.initCounter2 = function(timeToZero, trId, tdId) {
		var counter = new PokerCounter(timeToZero, trId, tdId);
		counterArr2.push(counter);
	};

	poker.tickCounter2 = function() {
		for (var i = 0; i < counterArr2.length; i++) {
			var counter = counterArr2[i];
			var oldTime = counter.timeToZero;

			var timeShowNodeHH;
			var timeShowNodeMM;
			var timeHH;
			var timeMM;
			if (counter.timeToZero <= 0) {
				var nodeDel = document.getElementById(counter.trId);
				nodeDel.parentNode.removeChild(nodeDel);
				counterArr2.splice(i, 1);
				poker.initStartTournamentTournPage();
				continue;
			} else if (counter.timeToZero < 1000 * 60) {
				timeMM = Math.floor(counter.timeToZero / 1000);
				timeShowNodeMM = 'SEC';
			} else if (counter.timeToZero < 1000 * 60 * 60) {
				timeMM = Math.floor(counter.timeToZero / (1000 * 60));
				timeShowNodeMM = 'MIN';
			} else {
				timeHH = Math.floor(counter.timeToZero / (1000 * 60 * 60));
				timeShowNodeHH = 'HOURS';
				timeMM = Math.floor((counter.timeToZero - timeHH * 60 * 60 * 1000) / (1000 * 60));
				timeShowNodeMM = 'MIN';
			}

			$('#' + counter.tdId + '-hh').text(timeHH);
			$('#' + counter.tdId + '-unit-hh').text(timeShowNodeHH);
			$('#' + counter.tdId + '-mm').text(timeMM);
			$('#' + counter.tdId + '-unit-mm').text(timeShowNodeMM);

			counter.timeToZero = oldTime - 1000;
		}

	};

	/**
	 * Functionality for filter of tournament
	 */
	var tournList = $('tr.tournamentSchedule');
	poker.filterGameType = function() {

		var selListType = document.getElementById('filter-game');
		var selValueType = selListType.options[selListType.selectedIndex].value;

		var selListLimit = document.getElementById('filter-limit');
		var selValueLimit = selListLimit.options[selListLimit.selectedIndex].value;

		var selListAmount = document.getElementById('filter-amount');
		var selValueAmount = selListAmount.options[selListAmount.selectedIndex].value;

		var nodesAll = $('tr.tournamentSchedule');

		var queryStr = '';

		if (selValueType === 'th') {
			queryStr = '[id*="&GameType=TexasHoldem"]';
		} else if (selValueType === 'oh') {
			queryStr = '[id*="&GameType=Omaha"]';
		} else if (selValueType === 'ohhl') {
			queryStr = '[id*="&GameType=OmahaHiLo"]';
		} else if (selValueType === 'scs') {
			queryStr = '[id*="&GameType=SevenCardStud"]';
		} else if (selValueType === 'scshl') {
			queryStr = '[id*="&GameType=SevenCardStudHiLo"]';
		}

		if (selValueLimit === 'nl') {
			queryStr = queryStr + '[id*="&Limit=NoLimit"]';
		} else if (selValueLimit === 'lim') {
			queryStr = queryStr + '[id*="&Limit=Limit"]';
		} else if (selValueLimit === 'pot') {
			queryStr = queryStr + '[id*="&Limit=Pot"]';
		}

		if (selValueAmount !== 'aa') {
			queryStr = queryStr + '[id*="&BuyInAmount=' + selValueAmount + '"]';
		}

		var nodesShow;
		if (queryStr && queryStr.length > 0) {
			nodesShow = $('tr' + queryStr);
		}

		for (var allNodesIndex = 0; allNodesIndex < nodesAll.length; allNodesIndex++) {
			if (!queryStr) {
				if (isInternetExplorerLessThanEight()) {
					nodesAll[allNodesIndex].style.display = 'block';
				} else {
					nodesAll[allNodesIndex].style.display = 'table-row';
				}
			} else {
				nodesAll[allNodesIndex].style.display = 'none';
			}
		}

		if (nodesShow.length > 0) {
			for (var showNodesIndex = 0; showNodesIndex < nodesShow.length; showNodesIndex++) {
				if (isInternetExplorerLessThanEight()) {
					nodesShow[showNodesIndex].style.display = 'block';
				} else {
					nodesShow[showNodesIndex].style.display = 'table-row';
				}
			}
			tournList = nodesShow;
		} else {
			tournList = nodesAll;
		}

		poker.setActivePokerPage(0);

	};

	poker.activePokerPage = 0;

	function setPreviousPokerpage() {
		if (poker.activePokerPage > 0) {
			poker.setActivePokerPage(poker.activePokerPage - 1);
		}
	}

	function setNextPokerpage() {
		poker.setActivePokerPage(poker.activePokerPage + 1);
	}

	function createActiveCallback(active) {
		var localActive = active;
		return function() {
			poker.setActivePokerPage(localActive);
		};
	}

	poker.setActivePokerPage = function(pageActive) {
		var PAGE_SIZE = 20;

		if (!pageActive) {
			pageActive = 0;
		}

		tournList = tournList || $('tr.tournamentSchedule');

		var nodesShow = tournList;
		var nrOfPage = 1;

		for (var nodeIndex = 0; nodeIndex < nodesShow.length; nodeIndex++) {
			if ((nodeIndex % PAGE_SIZE) === 0 && nodeIndex !== 0) {
				nrOfPage++;
			}

			if (nodeIndex >= PAGE_SIZE * pageActive && nodeIndex < PAGE_SIZE * (pageActive + 1)) {

				if (isInternetExplorerLessThanEight()) {
					nodesShow[nodeIndex].style.display = 'block';
				} else {
					nodesShow[nodeIndex].style.display = 'table-row';
				}
			} else {
				nodesShow[nodeIndex].style.display = 'none';
			}
		}

		// Clear the navigation links
		var pageList = document.getElementById('upcoming-tournaments-pageing-list');
		pageList.innerHTML = '';

		if (nrOfPage > 1) {

			// Setting first position of navigation links
			if (pageActive > 0) {
				var textNode = document.createTextNode('Previous');
				var aNode = document.createElement('a');
				aNode.onclick = setPreviousPokerpage;
				aNode.appendChild(textNode);
				var liEl = document.createElement('li');
				liEl.appendChild(aNode);
				pageList.appendChild(liEl);
			}

			var navLength = 5;
			var min;
			var max;

			if (nrOfPage > navLength) {
				min = pageActive - Math.floor(navLength / 2);
				max = pageActive + Math.floor(navLength / 2);
				while (true) {
					if (min < 0) {
						min = min + 1;
						max = max + 1;
					} else if (max > nrOfPage - 1) {
						max = max - 1;
						min = min - 1;
					} else {
						break;
					}
				}

			} else {
				min = 0;
				max = nrOfPage;
			}

			// Decide limits of navigation links
			var botElNr = min;
			var topElNr = max;

			for (var i = 0; i < nrOfPage; i++) {
				var textNode2;
				if (i >= botElNr && i <= topElNr) {
					textNode2 = document.createTextNode(i + 1);
				} else if (i === nrOfPage - 1) {
					textNode2 = document.createTextNode('...' + (i + 1));
				} else {
					continue;
				}

				var aNode2 = document.createElement('a');
				if (i === pageActive) {
					aNode2.className = 'selected';
				}
				aNode2.onclick = createActiveCallback(i);
				aNode2.appendChild(textNode2);
				var liEl2 = document.createElement('li');
				liEl2.appendChild(aNode2);

				if (i >= botElNr && i <= topElNr) {
					pageList.appendChild(liEl2);
				} else if (i === nrOfPage - 1) {
					pageList.appendChild(liEl2);
				}

			}
			if (pageActive !== nrOfPage - 1) {
				var textNode3 = document.createTextNode('Next');
				var aNode3 = document.createElement('a');
				aNode3.onclick = setNextPokerpage;
				aNode3.appendChild(textNode3);
				var liEl3 = document.createElement('li');
				liEl3.appendChild(aNode3);
				pageList.appendChild(liEl3);
			}
		}

		poker.activePokerPage = pageActive;
	};

	poker.openTournament = function(tournamentId) {
		dialog.flow('tournaments&POKER_TOURNAMENT_ID=' + tournamentId);
	};

	var nrTournament = 6;
	poker.load = function() {
		var $poker = $('#poker-wrapper');
		$poker.show();

		poker.changeNavTab('tab-pokerstart');

		poker.initStartTournamentStartPage(nrTournament);

		for (var i1 = 0; i1 < window.initCounterList1; i1++) {
			var item1 = window.initCounterList1[i1];
			poker.initCounter(item1[0], item1[1], item1[2]);
		}
		for (var i2 = 0; i2 < window.initCounterList2; i2++) {
			var item2 = window.initCounterList2[i2];
			poker.initCounter2(item2[0], item2[1], item2[2]);
		}

		poker.initStartTournamentTournPage(nrTournament);
		poker.setActivePokerPage(0);

		setInterval(poker.tickAllCounters, 1000);

		// TODO: this is starting <tlt:promotion> output, fix and make nice
		if (typeof(window.loadPromoBanner) !== 'undefined' && $.isFunction(window.loadPromoBanner)) {
			window.loadPromoBanner();
		}

		function changeUrl(current) {
			if (current.indexOf(configuration.POKER_TAB_TOURNAMENTS) === 1) {
				if (current.indexOf('&id=') !== -1) {
					var id = current.split('=')[1];
					poker.openTournament(id);
				} else {
					poker.changeNavTab('tab-tournaments');
				}
			} else if (current.indexOf(configuration.POKER_TAB_START) === 1) {
				poker.changeNavTab('tab-pokerstart');
			}
			else if (current.indexOf(configuration.POKER_TAB_REWARDS) === 1) {
				poker.changeNavTab('tab-rewards');
			}
			else if (current.indexOf(configuration.POKER_TAB_DOWNLOAD) === 1) {
				poker.changeNavTab('tab-download');
			}
		}

		// TODO: use standard navigation when moving to wrapper, this lifted from old main_js.jsp
		setInterval(function() {
			var current = window.location.hash;
			if (current !== poker.previousHash) {
				poker.previousHash = current;
				if (typeof changeUrl === 'function') {
					current = current.replace('?', '&');
					if (current.indexOf('!') === 1) {
						changeUrl('#' + current.substring(2));
					} else {
						changeUrl(current);
					}
				}
			}
		}, 100);

		function setBonusLink() {
			if (session.authenticated) {
				$('a#tab-bonuses').attr('href', prettyLinks.getLink('MyPages', 'MyBonuses'));
			} else {
				$('a#tab-bonuses').attr('href', prettyLinks.getLink('Promotions'));
			}
		}

		$poker.find('a.logged-out').click(slidingContentWrapper.showSlidingSignup);

		$(session).on('login logout', function() {
			setBonusLink();
		});
		setBonusLink();

		footer.pixelTrack('POKER');
		$(footer.show);

	};

	poker.preload = $.noop;
	return poker;

});

